function getAmountMenWomen(diagramData: any) {
    const totalAmount = diagramData.SalariesMen.length + diagramData.SalariesWomen.length
    const amountMen = Math.round((diagramData.SalariesMen.length / totalAmount) * 100)
    const amountWomen = Math.round((diagramData.SalariesWomen.length / totalAmount) * 100)
    return { Men: amountMen, Women: amountWomen }
}

export default getAmountMenWomen
